// Initialize Service Worker for audio caching
import serviceWorkerManager from '../services/serviceWorkerManager'

/**
 * Initialize the audio cache service worker
 * Call this once when the app starts
 */
export const initAudioCacheServiceWorker = async () => {
  // Only register in production or if explicitly enabled
  const isDevelopment = import.meta.env.DEV
  const forceEnable = import.meta.env.VITE_ENABLE_SW === 'true'

  if (isDevelopment && !forceEnable) {
    return false
  }

  if (!serviceWorkerManager.isSupported) {
    return false
  }

  try {
    const registered = await serviceWorkerManager.register()
    return registered
  } catch (error) {
    return false
  }
}

/**
 * Clear all cached audio files
 */
export const clearAudioCache = async () => {
  try {
    await serviceWorkerManager.clearCache()
    return true
  } catch (error) {
    return false
  }
}

/**
 * Get audio cache statistics
 */
export const getAudioCacheStats = async () => {
  try {
    const size = await serviceWorkerManager.getCacheSize()
    const status = serviceWorkerManager.getStatus()

    return {
      cacheSize: size,
      ...status
    }
  } catch (error) {
    return {
      cacheSize: 0,
      supported: false,
      registered: false,
      active: false
    }
  }
}
